// extracted by mini-css-extract-plugin
export default {"root":"Tools_root__3KYYv","flex":"Tools_flex__69k8r","types":"Tools_types__AfeUz"};